































import 'vue-height-tween-transition/index.css'
import HeightTween from 'vue-height-tween-transition'

export default
	inject:
		isChild:
			default: false

	provide:
		isChild: true

	components: { HeightTween }

	props:
		title: String
		ariaTitle: String
		open: Boolean
		uncloseable: Boolean
		paneWidth: String

	# Store our own pane state, so this can be used in isolation or as part of
	# an accordion where only one is open at a time
	data: -> isOpen: @open

	computed:

		# Disable the pane if it is uncloseable and open
		disabled: -> @uncloseable && @isOpen

		# label for the expanded state
		# this is set to 'true' and 'false' strings
		# so that it's always present and has the right label
		# https://app.asana.com/0/1200777795870740/1202888345679627/f
		expandedLabel: ->
			if @isOpen then return 'true'
			else return 'false'

		# render the aria title prop if exists, or just the regular title
		smartTitle: -> @ariaTitle || @title


	watch:

		# Sync the open state
		open: -> @isOpen = @open

		# Even events when it's opened / closed
		isOpen: ->
			if @isOpen then @$emit 'open' else @$emit 'close'
			@$emit 'toggle', @isOpen


	methods:

		# Handle toggle clicks
		onToggle: ->
			return if @uncloseable and @isOpen
			@isOpen = !@isOpen

